/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { infoDisplayStylesTwoV2, InfoDisplayStylesV2 } from "@eisinc/App/SharedStyles/InfoDisplayStylesV2";
import { OrderDetailsPageContext } from "@eisinc/Overrides/Pages/OrderDetailsPage";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface OrderDetailsOrderedByStyles {
    wrapper?: InjectableCss;
}

export const orderDetailsOrderedByStyles: OrderDetailsOrderedByStyles = {
    wrapper: {
        css: css`
            ${infoDisplayStylesTwoV2.wrapper?.css}
            margin-top: 10px;
        `,
    },
};

const styles = mergeToNew(infoDisplayStylesTwoV2, orderDetailsOrderedByStyles);

const OrderDetailsOrderedBy: FC = () => {
    const { value: order } = useContext(OrderStateContext);

    if (!order || !order.properties || (!order.properties.orderedBy && !order.properties.contactName)) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderDetailsOrderedBy">
                {translate("Ordered By")}
            </Typography>
            {order.properties.orderedBy && (
                <Typography {...styles.contentText} aria-labelledby="orderDetailsOrderedBy" as="p">
                    {order.properties.orderedBy}
                </Typography>
            )}
            {order.properties.contactName && (
                <Typography {...styles.contentText} aria-labelledby="orderDetailsOrderedBy" as="p">
                    {order.properties.contactName}
                </Typography>
            )}
            {order.properties.contactPhone && (
                <Typography {...styles.contentText} aria-labelledby="orderDetailsOrderedBy" as="p">
                    {order.properties.contactPhone}
                </Typography>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsOrderedBy,
    definition: {
        allowedContexts: [OrderDetailsPageContext],
        group: "Order Details",
    },
};

export default widgetModule;
